import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZorinComponent } from './simple-icons-zorin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZorinComponent ],
    exports:      [ SimpleIconsZorinComponent ],
    bootstrap:    []
})
export class SimpleIconsZorinModule {}
